import type { TOC } from '@ember/component/template-only';
import { PrismCard, PrismMessage } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import { eq } from 'ember-truth-helpers';
import RegisterErrorCardHeaderTitle from 'frontend-login/components/register-error/card-header-title';
import RegisterErrorTokenExpired from 'frontend-login/components/register-error/token-expired';
import {
  TOKEN_EXPIRED_ERROR_CAUSE,
  type TokenExpiredError,
} from 'frontend-login/routes/register';
import styles from 'frontend-login/templates/register-error.module.css';

interface RegisterErrorArgs {
  model: Error | TokenExpiredError;
}

<template>
  <main class={{styles.container-main}}>
    {{#if (eq @model.cause TOKEN_EXPIRED_ERROR_CAUSE)}}
      <RegisterErrorTokenExpired />
    {{else}}
      <PrismCard>
        <:header as |Header|>
          <Header.title>
            <RegisterErrorCardHeaderTitle />
          </Header.title>
        </:header>
        <:content>
          <PrismMessage
            @description={{t "password.error.invalid_link"}}
            @illustration="100x100_tangled"
            @title={{t "general.error_title"}}
          />
        </:content>
      </PrismCard>
    {{/if}}
  </main>
</template> satisfies TOC<RegisterErrorArgs>;
